export enum TypePosition {
    gps = 'gps',
    manuel = 'manuel',
    inconnu = 'inconnu'
}
